import { render, staticRenderFns } from "./register-user-form.vue?vue&type=template&id=396f46eb&scoped=true&"
import script from "./register-user-form.vue?vue&type=script&lang=js&"
export * from "./register-user-form.vue?vue&type=script&lang=js&"
import style0 from "./register-user-form.vue?vue&type=style&index=0&id=396f46eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396f46eb",
  null
  
)

export default component.exports